import type { MapPreviewView } from "../../enums/map";
import { MAP_PREVIEW_VIEW } from "../../enums/map";

const VIEWS: Array<{
  key: MapPreviewView;
  label: string;
  description: string;
}> = [
  {
    key: MAP_PREVIEW_VIEW.BASELINE,
    label: "Current baseline",
    description: "Scan and Current Paths evidence",
  },
  {
    key: MAP_PREVIEW_VIEW.ARCHITECTURE,
    label: "Recommended architecture",
    description: "Draft structural actions",
  },
  {
    key: MAP_PREVIEW_VIEW.MIGRATION,
    label: "Migration plan",
    description: "Indicative delivery waves",
  },
];

export function MapPreviewNav(props: {
  view: MapPreviewView;
  onChange: (view: MapPreviewView) => void;
}) {
  return (
    <>
      <nav class="map-preview-nav" aria-label="Signal Map preview views">
        {VIEWS.map((view, index) => (
          <button
            type="button"
            classList={{ "is-active": props.view === view.key }}
            aria-current={props.view === view.key ? "page" : undefined}
            onClick={() => props.onChange(view.key)}
          >
            <span>0{index + 1}</span>
            <strong>{view.label}</strong>
            <small>{view.description}</small>
          </button>
        ))}
      </nav>
      <div class="map-preview-provenance">
        <strong>Preview · Derived from current scan evidence</strong>
        <p>
          Current structure and Current Paths describe the current estate. Map
          organises a draft future-state response. No target architecture
          decision is saved.
        </p>
      </div>
    </>
  );
}
